// @ts-strict-ignore
import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler } from "@angular/common/http";
import { Store } from "@ngrx/store";
import { first } from "rxjs/operators";
import { AppState } from "src/app/ngrx/root.reducer";
import { AuthSelectors } from "../../ngrx/auth.selectors.types";

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  constructor(private store: Store<AppState>) {}

  intercept(request: HttpRequest<unknown>, callback: HttpHandler) {
    let isAuthenticated: boolean;
    let accessToken: string;

    this.store
      .select(AuthSelectors.isAuthenticated)
      .pipe(first())
      .subscribe((response) => {
        isAuthenticated = response;
      });

    this.store
      .select(AuthSelectors.accessToken)
      .pipe(first())
      .subscribe((response) => {
        accessToken = response;
      });

    if (isAuthenticated) {
      return callback.handle(
        request.clone({
          headers: request.headers.set("Authorization", `Bearer ${accessToken}`)
        })
      );
    } else {
      return callback.handle(request);
    }
  }
}
